import React, { useState, useEffect, useCallback } from "react"
import Notification from "../Notification"
import AdHoc from '../AdHoc'

import AdHocIcon from '../../assets/icons/map/AdHocLightBulb.svg'
import nyBoundaryCoords from '../../assets/nyboundary.json'

const ZOOM_LEVEL_FOR_ASSET_LOAD = 18

export const OutsideBoundaryNotification = () => {
  return (
    <Notification   
      className= {window.location.href.split('/').pop() === 'InventoryReport' ? "notification-warning  notification-invmap" :"notification-warning notification-map"}  data-test='notification-warning'>
      You're attempting to report a problem outside the area served by National Grid.<br/>
      Please try again by giving a location within our service area outlined in BLUE.
    </Notification>
  )
}

const GoogleMapBoundary = ({ map, nestModal, setAsset, setNestModal, setPolygon1, setPolygon2, setPolygon3 }) => {
  
  const inventoryReportMap = window.location.href.split('/').pop() === 'InventoryReport'

  const [outsideWarning, setOutsideWarning] = useState(false)
  

  const sleep = async (ms) => {
    return new Promise((resolve, reject) => {
      if (isNaN(ms)) {
        reject(new Error('sleep requires a valid number'))
      } else {
        window.setTimeout(resolve, ms)
      }
    })
  }

  const onclickOpen = useCallback(() => {
    setNestModal(true)
  }, [setNestModal])

  const bound = ( coords ) => {
    let polygonCoords = []
    for (let i = 0; i < coords.length; i++) {
      for (let j = 0; j < coords[i].length; j++) {
        let pt = new window.google.maps.LatLng(coords[i][j][1], coords[i][j][0])
        polygonCoords.push(pt)
      }

    }
    // Construct the polygon.
    let polygon = new window.google.maps.Polygon({
      paths: polygonCoords,
    })
    
    return polygon
  }

  useEffect(() => {
    let timer5000
    map.data.addGeoJson(nyBoundaryCoords)
    const featureStyle = () => ({
      strokeColor: '#00148C',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: 'transparent',
      fillOpacity: 0.35,
    })

    map.data.setStyle(featureStyle)

    const markerIcon = () => {
      let icon = AdHocIcon
      let iconStatus = 4
      return {
        url: icon,
        iconStatus,
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(21,20),
      }
    }

    const boundaryClickListener = (mapsMouseEvent) => {
      let location = mapsMouseEvent.latLng
      const icon = markerIcon()
      
      setOutsideWarning(false)

      if(map.getZoom() >= ZOOM_LEVEL_FOR_ASSET_LOAD && !inventoryReportMap) {
        const marker = new window.google.maps.Marker({
          map,
          icon,
          position: location,
        })

        AdHoc(map, marker, nestModal, setAsset, onclickOpen)
      } 

    }

    const mapClickListener = async (ev) => {
      setOutsideWarning(true)
      timer5000 = sleep(5000)
      await timer5000
      setOutsideWarning(false)
    }

    map && map.data.addListener('click', boundaryClickListener)
    map && map.addListener('click', mapClickListener)
    return () => {
      window.clearTimeout(timer5000)
      map && map.data.removeListener && map.data.removeListener('click', boundaryClickListener)
      map && map.removeListener && map.removeListener('click', mapClickListener)
    }
    // eslint-disable-next-line
  }, [map])

  useEffect(() => {
    const coords1 = nyBoundaryCoords.features[0].geometry.coordinates
    const coords2 = nyBoundaryCoords.features[1].geometry.coordinates
    const coords3 = nyBoundaryCoords.features[2].geometry.coordinates
    setPolygon1(bound(coords1))
    setPolygon2(bound(coords2))
    setPolygon3(bound(coords3))
    // eslint-disable-next-line
  },[])

  return (<div data-test="boundary-warning">
    {outsideWarning && <OutsideBoundaryNotification />}
  </div>)
}

export default GoogleMapBoundary